import React, { useState } from 'react';
import Icon from '../../../AppIcon';
import Button from '../../../ui/Button';

const SavedSearches = ({ onLoadSearch, onDeleteSearch }) => {
  const [savedSearches] = useState([
    {
      id: 1,
      name: "FinTech Accelerators",
      query: "fintech accelerator",
      filters: {
        industry: "fintech",
        stage: "seed",
        location: "north-america"
      },
      resultCount: 24,
      lastUpdated: "2024-11-13",
      alertsEnabled: true
    },
    {
      id: 2,
      name: "AI/ML Partnerships",
      query: "artificial intelligence machine learning",
      filters: {
        industry: "ai-ml",
        programType: "partnership",
        fundingRange: "1m-5m"
      },
      resultCount: 18,
      lastUpdated: "2024-11-12",
      alertsEnabled: false
    },
    {
      id: 3,
      name: "European Growth Programs",
      query: "",
      filters: {
        location: "europe",
        stage: "series-a",
        programType: "accelerator"
      },
      resultCount: 31,
      lastUpdated: "2024-11-11",
      alertsEnabled: true
    }
  ]);

  const [isExpanded, setIsExpanded] = useState(false);

  const handleLoadSearch = (search) => {
    onLoadSearch(search);
  };

  const handleDeleteSearch = (searchId) => {
    if (window.confirm('Are you sure you want to delete this saved search?')) {
      onDeleteSearch(searchId);
    }
  };

  const toggleAlerts = (searchId) => {
    // This would typically update the search in the backend
    console.log('Toggle alerts for search:', searchId);
  };

  if (savedSearches?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="text-center">
          <Icon name="Bookmark" size={32} className="text-muted-foreground mx-auto mb-3" />
          <h3 className="text-lg font-semibold text-foreground mb-2">No Saved Searches</h3>
          <p className="text-sm text-muted-foreground">
            Save your search criteria to quickly access them later
          </p>
        </div>
      </div>
    );
  }

  const displayedSearches = isExpanded ? savedSearches : savedSearches?.slice(0, 3);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Bookmark" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Saved Searches</h3>
          <span className="bg-muted text-muted-foreground text-xs px-2 py-1 rounded-full">
            {savedSearches?.length}
          </span>
        </div>
        {savedSearches?.length > 3 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
          >
            {isExpanded ? 'Show Less' : `Show All (${savedSearches?.length})`}
          </Button>
        )}
      </div>
      <div className="space-y-3">
        {displayedSearches?.map((search) => (
          <div
            key={search?.id}
            className="flex items-center justify-between p-3 bg-muted/50 rounded-lg hover:bg-muted transition-colors"
          >
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <h4 className="font-medium text-foreground truncate">{search?.name}</h4>
                {search?.alertsEnabled && (
                  <Icon name="Bell" size={14} className="text-primary" />
                )}
              </div>
              
              <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                <span>{search?.resultCount} results</span>
                <span>Updated {search?.lastUpdated}</span>
                {search?.query && (
                  <span className="truncate max-w-32">"{search?.query}"</span>
                )}
              </div>
              
              {/* Filter Tags */}
              <div className="flex flex-wrap gap-1 mt-2">
                {Object.entries(search?.filters)?.map(([key, value]) => (
                  value && (
                    <span
                      key={key}
                      className="px-2 py-0.5 bg-background text-muted-foreground text-xs rounded"
                    >
                      {key}: {value}
                    </span>
                  )
                ))}
              </div>
            </div>
            
            <div className="flex items-center space-x-2 ml-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleAlerts(search?.id)}
                iconName={search?.alertsEnabled ? "BellRing" : "Bell"}
                iconSize={14}
                className="text-muted-foreground hover:text-foreground"
              />
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleLoadSearch(search)}
                iconName="Play"
                iconSize={14}
                className="text-primary hover:text-primary"
              />
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleDeleteSearch(search?.id)}
                iconName="Trash2"
                iconSize={14}
                className="text-destructive hover:text-destructive"
              />
            </div>
          </div>
        ))}
      </div>
      {savedSearches?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Plus"
            iconPosition="left"
          >
            Save Current Search
          </Button>
        </div>
      )}
    </div>
  );
};

export default SavedSearches;